// import playgol from './ligas/playgol'
// import barrionuevo from './ligas/barrionuevo'
// import barrionuevo from './ligas/barrionuevo'
// // import monterrico from './ligas/monterrico'

// const tenants = {
//   playgol,
//   barrionuevo,
// //   monterrico,
// }

// const tenantName = process.env.VUE_APP_FOLDER || 'playgol'

// export default tenants[tenantName]
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */

const tenantName = process.env.VUE_APP_FOLDER

export default require(`./ligas/${tenantName}`).default
